<div class="toast-message">
  <div
    data-cy="toast-message"
    (mouseover)="onMouseOver(toastMessage, $event)"
    (mouseleave)="onMouseOut(toastMessage, $event)"
    *ngFor="
      let toastMessage of toastMessages;
      let index = index;
      let isFirst = first;
      let isLast = last
    "
    class="toast-message__container flex-row {{ toastMessage.type }}"
    id="toast-{{ toastMessage.id }}"
  >
    <div class="toast-message__container__toaster__icon flex-centered">
      <mat-icon>{{ toastMessage.icon }}</mat-icon>
    </div>

    <div class="flex-centered flex-grow-1">
      <div
        data-cy="toast-message-description"
        class="toast-message__container__toaster__text"
        [innerHTML]="toastMessage.description"
      ></div>
    </div>

    <div
      data-cy="toast-message-close"
      matRipple
      class="toast-message__container__toaster__close"
      (click)="close(toastMessage, $event)"
    >
      <mat-icon>close</mat-icon>
    </div>
  </div>
</div>
